export const validateEmailField = (value?: string) => {
  if (!value) return { isValid: true, message: "" };

  const validationChecks = [
    {
      condition: !value.includes("@"),
      message: "【メールアドレスの値が不正】@マークが含まれていません。",
    },
    {
      condition: (value.match(/@/g) || []).length > 1,
      message: "【メールアドレスの値が不正】@マークが複数含まれています。",
    },
    {
      condition: value.includes(" "),
      message: "【メールアドレスの値が不正】スペースが含まれています。",
    },
  ];

  for (const check of validationChecks) {
    if (check.condition) {
      return { isValid: false, message: check.message };
    }
  }

  const parts = value.split("@");
  if (parts.length !== 2 || !parts[0] || !parts[1]) {
    return {
      isValid: false,
      message:
        "【メールアドレスの値が不正】メールアドレスの形式が正しくありません。",
    };
  }

  const [localPart, domainPart] = parts;

  // Domain validation
  if (!domainPart.includes(".")) {
    return {
      isValid: false,
      message:
        "【メールアドレスの値が不正】ドメイン名が不正です（.が含まれていません）。",
    };
  }

  const domainParts = domainPart.split(".");
  const extension = domainParts[domainParts.length - 1];
  if (extension.length < 2 || extension.length > 63) {
    return {
      isValid: false,
      message:
        "【メールアドレスの値が不正】ドメイン拡張子は2-63文字である必要があります。",
    };
  }

  // Character validation
  const allowedLocalChars = /^[\w.-]+$/;
  if (!allowedLocalChars.test(localPart)) {
    const invalidChars = localPart.match(/[^\w.-]/g);
    return {
      isValid: false,
      message: `【メールアドレスの値が不正】使用できない文字が含まれています: ${
        invalidChars?.join(", ") || "特殊文字"
      }`,
    };
  }

  const allowedDomainChars = /^[\w.-]+$/;
  if (!allowedDomainChars.test(domainPart)) {
    return {
      isValid: false,
      message:
        "【メールアドレスの値が不正】ドメイン名に使用できない文字が含まれています。",
    };
  }

  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/;
  if (!emailRegex.test(value)) {
    return {
      isValid: false,
      message:
        "【メールアドレスの値が不正】正しい形式で入力してください（例: user@example.com）。",
    };
  }

  return { isValid: true, message: "" };
};
